var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_12668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2987 9.60901L9.14578 6.59015C8.99337 6.47967 8.79105 6.46303 8.624 6.54888C8.45562 6.63407 8.35046 6.80711 8.35046 6.99413V13.0299C8.35046 13.2189 8.45562 13.3913 8.624 13.4764C8.69521 13.5124 8.77308 13.5303 8.85161 13.5303C8.9541 13.5303 9.05793 13.4977 9.14578 13.4332L13.2987 10.417C13.4298 10.3205 13.5064 10.1714 13.5064 10.013C13.507 9.85194 13.4285 9.70352 13.2987 9.60901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 0.00134277C4.47639 0.00134277 0 4.47773 0 10.0017C0 15.5236 4.47639 19.9987 10.0003 19.9987C15.5229 19.9987 20 15.523 20 10.0017C20.0007 4.47773 15.5229 0.00134277 10.0003 0.00134277ZM10.0003 18.3302C5.40015 18.3302 1.67049 14.6025 1.67049 10.0017C1.67049 5.40283 5.40015 1.67051 10.0003 1.67051C14.5998 1.67051 18.3288 5.40216 18.3288 10.0017C18.3295 14.6025 14.5998 18.3302 10.0003 18.3302Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_12668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.ce5d483ae827f6371898c3a3c9af2818.svg";
export { ForwardRef as ReactComponent };